import Icon from "../Icon";
import {Communication} from "../../../util/types";
import IconMail from "../../icons/IconMail.tsx";
import IconMailOpen from "../../icons/IconMailOpen.tsx";

interface NotificationButtonsProps {
    request: Communication;
    isOpen: boolean;
    onToggleOpen: (isOpen: boolean) => void;
    onToggleRead: (request: Communication) => void;
}

export default function NotificationButtons({request, onToggleRead, onToggleOpen, isOpen}: NotificationButtonsProps) {
    return <nav className="notification-buttons">
            <button onClick={() => onToggleRead(request)} className="toggle-read">
                <span className="text">Markér som {request.read_dtm ? 'ulæst' : 'læst'}</span>
                <Icon component={request.read_dtm ? IconMail : IconMailOpen}/>
            </button>

            <button className="toggle-open" onClick={() => onToggleOpen(!isOpen)}>
                <span className="text">{isOpen ? 'Luk' : 'Åbn'} besked</span>
                <span className={"arrow" + (isOpen ? " arrow-up" : " arrow-down")}></span>
            </button>
        </nav>
}
